import { createFileRoute } from "@tanstack/react-router";
import { DashboardShell } from "@/components/floodwatch/dashboard-shell";

export const Route = createFileRoute("/admin/")({
  head: () => ({
    meta: [
      { title: "Operations dashboard" },
      {
        name: "description",
        content: "Alert queue, risk map, audit log, and delivery operations.",
      },
    ],
  }),
  component: AdminAppPage,
});

function AdminAppPage() {
  return <DashboardShell workspace="operations" />;
}
